module.exports = require('./$.hide');


//////////////////
// WEBPACK FOOTER
// D:/midea_porject/php/htdocs/~/core-js/library/modules/$.redefine.js
// module id = 21
// module chunks = 0